/* 智慧养殖数据 */

/* 搜索数据 */
export const resetOrSearch = [
  { title: '重置', icon: 'el-icon-refresh', class: 'btReset', event: 'resetForm' },
  { title: '搜索', icon: 'el-icon-search', class: 'btSerch', event: 'submitForm' }
];

/* 大数据管理 */

// 大数据管理
export const datasNavData = [{ title: '大数据管理', to: { path: '/homeZ/datas' } }, { title: '大数据展示' }];

/* 牧场设备管理 */

// 实时监控管理
export const pdaListNavData = [{ title: '牧场设备管理', to: { path: '/homeZ/pdaList' } }, { title: '实时监控管理' }];

export const pdaListTitleData = {
  title: '实时监控管理',
  totalType: '条',
  bntList: []
};

/* 智能设备 */

// 设备列表
export const smartDevicesNavData = [{ title: '智能设备', to: { path: '/homeZ/smartDevices' } }, { title: '设备列表' }];

export const smartDevicesTitleData = {
  title: '设备列表',
  totalType: '台设备',
  bntList: [{ icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid' }]
};

// 感知状态一张图
export const perceivedStateNavData = [{ title: '智能设备', to: { path: '/homeZ/smartDevices' } }, { title: '感知状态一张图' }];

export const perceivedStateTitleData = {
  title: '感知状态一张图',
  totalType: '条',
  bntList: []
};

// 精准调控系统
export const regulatorySystemNavData = [{ title: '智能设备', to: { path: '/homeZ/smartDevices' } }, { title: '精准调控系统' }];

export const regulatorySystemTitleData = {
  title: '精准调控系统',
  totalType: '台设备',
  bntList: []
};

/* 畜只管理 */

// 在栏畜只
export const intheBarNavData = [{ title: '畜只管理', to: { path: '/homeZ/intheBar' } }, { title: '在栏畜只' }];

export const intheBarTitleData = {
  title: '在栏畜只',
  totalType: '',
  bntList: [{ icon: 'el-icon-upload2', name: '批量出栏', click: 'batchListing', type: '' }]
};

// 免疫记录
export const immuneNavData = [{ title: '畜只管理', to: { path: '/homeZ/intheBar' } }, { title: '免疫记录' }];

export const immuneTitleData = {
  title: '免疫记录',
  totalType: '',
  bntList: []
};

// 用药记录
export const medicineNavData = [{ title: '畜只管理', to: { path: '/homeZ/intheBar' } }, { title: '用药记录' }];

export const medicineTitleData = {
  title: '用药记录',
  totalType: '',
  bntList: []
};

// 繁育记录
export const breedNavData = [{ title: '畜只管理', to: { path: '/homeZ/intheBar' } }, { title: '繁育记录' }];

export const breedTitleData = {
  title: '配种记录',
  totalType: '',
  bntList: []
};

export const breedTabData = [
  { title: '配种记录', mark: 'first' },
  { title: '生产记录', mark: 'second' }
];

// 出栏/淘汰
export const suchNavData = [{ title: '畜只管理', to: { path: '/homeZ/intheBar' } }, { title: '出栏/淘汰' }];

export const suchTitleData = {
  title: '出栏',
  totalType: '',
  bntList: []
};

export const suchTabData = [
  { title: '出栏', mark: 'first' },
  { title: '淘汰', mark: 'second' }
];

/* 物料管理 */

// 物料信息
export const infoNavData = [{ title: '物料管理', to: { path: '/homeZ/info' } }, { title: '物料信息' }];

export const infoTitleData = {
  title: '物料信息',
  totalType: '',
  bntList: [{ icon: 'el-icon-plus', name: '新增物料', click: 'add', type: 'solid' }]
};

// 入库记录
export const listNavData = [{ title: '物料管理', to: { path: '/homeZ/info' } }, { title: '入库记录' }];

export const listTitleData = {
  title: '入库记录',
  totalType: '',
  bntList: [{ icon: 'el-icon-upload2', name: '批量导出', click: 'export', type: '' }]
};

// 使用记录
export const outNavData = [{ title: '物料管理', to: { path: '/homeZ/info' } }, { title: '使用记录' }];

export const outTitleData = {
  title: '使用记录',
  totalType: '',
  bntList: [{ icon: 'el-icon-upload2', name: '批量导出', click: 'export', type: '' }]
};

/* 圈舍管理 */

// 区管理
export const distinguishNavData = [{ title: '圈舍管理', to: { path: '/homeZ/distinguish' } }, { title: '区管理' }];

export const distinguishTitleData = {
  title: '区管理',
  totalType: '',
  bntList: [{ icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid' }]
};

// 棚管理
export const shedManagementNavData = [{ title: '圈舍管理', to: { path: '/homeZ/distinguish' } }, { title: '棚管理' }];

export const shedManagementTitleData = {
  title: '棚管理',
  totalType: '',
  bntList: [
    { icon: 'el-icon-download', name: '下载模版', click: 'downLoad', type: '' },
    { icon: 'el-icon-document-add', name: '导入数据', click: 'import', type: '', function: 'import' },
    { icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid' }
  ]
};

// 栏管理
export const columnManagementNavData = [{ title: '圈舍管理', to: { path: '/homeZ/distinguish' } }, { title: '栏管理' }];

export const columnManagementTitleData = {
  title: '栏管理',
  totalType: '',
  bntList: [
    { icon: 'el-icon-download', name: '下载模版', click: 'downLoad', type: '' },
    { icon: 'el-icon-document-add', name: '导入数据', click: 'import', type: '', function: 'import' },
    { icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid' }
  ]
};

/* 系统设置 */

// 基础信息
export const systemSettingNavData = [{ title: '系统设置', to: { path: '/system/systemSetting' } }, { title: '基础信息' }];

// 人员管理
export const userNavData = [{ title: '系统设置', to: { path: '/system/systemSetting' } }, { title: '人员管理' }];

export const userTitleData = {
  title: '人员管理',
  totalType: '',
  bntList: [{ icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid' }]
};

// 角色管理
export const userGroupNavData = [{ title: '系统设置', to: { path: '/system/systemSetting' } }, { title: '角色管理' }];

export const userGroupTitleData = {
  title: '角色管理',
  totalType: '',
  bntList: [{ icon: 'el-icon-plus', name: '新增', click: 'add', type: 'solid' }]
};

// 菜单管理
export const userCaidanNavData = [{ title: '系统设置', to: { path: '/system/systemSetting' } }, { title: '菜单管理' }];

export const userCaidanTitleData = {
  title: '菜单管理',
  totalType: '',
  bntList: []
};

// 操作日志
export const operationLogNavData = [{ title: '系统设置', to: { path: '/system/systemSetting' } }, { title: '操作日志' }];

export const operationLogTitleData = {
  title: '操作日志',
  totalType: '',
  bntList: []
};

// 登录日志
export const loginLogNavData = [{ title: '系统设置', to: { path: '/system/systemSetting' } }, { title: '登录日志' }];

export const loginLogTitleData = {
  title: '登录日志',
  totalType: '',
  bntList: []
};

/* 饲喂管理 */
export const feedingVehiclesNavData = [{ title: '饲喂管理', to: { path: '/homeZ/feedingVehicles' } }, { title: '饲喂车辆' }];
export const feedingVehiclesTitleData = {
  title: '饲喂车辆',
  totalType: '',
  bntList: []
};
export const feedingVehiclesSearchData = [
  {
    key: 'deviceType',
    types: 'select',
    value: '',
    valueName: 'deviceType',
    placeholder: '请选择设备类型',
    clearable: true,
    option: {
      data: [],
      label: 'label',
      value: 'value'
    },
    style: {
      width: '150px'
    },
    appendToBody: true
  },
  {
    key: 'deviceName',
    types: 'input',
    value: '',
    valueName: 'deviceName',
    placeholder: '请输入设备名称搜索',
    clearable: true,
    style: {
      width: '200px'
    }
  },
  {
    key: 'workStatus',
    types: 'select',
    value: '',
    valueName: 'workStatus',
    placeholder: '请选择工作状态',
    clearable: true,
    option: {
      data: [],
      label: 'label',
      value: 'value'
    },
    style: {
      width: '150px'
    },
    appendToBody: true
  },
  {
    key: 'deviceOnline',
    types: 'select',
    value: '',
    valueName: 'deviceOnline',
    placeholder: '请选择车辆状态',
    clearable: true,
    option: {
      data: [
        { label: '请选择车辆状态', value: '' },
        { label: '在线', value: '0' },
        { label: '离线', value: '1' }
      ],
      label: 'label',
      value: 'value'
    },
    style: {
      width: '150px'
    },
    appendToBody: true
  }
];
export const feedingVehiclesTableHeaderData = [
  {
    label: '设备类型',
    width: '120',
    comOption: {
      name: 'deviceType',
      option: [
        { label: '撒料车', value: '3' },
        { label: '检测车', value: '6' },
        { label: '饲喂机器人', value: '7' }
      ]
    },
    show: false
  },
  {
    label: '设备名称',
    multipleLine: true,
    width: '200',
    multipleData: [
      { color: 'blue', text: 'deviceName', tooltip: false },
      { color: 'color9', text: 'deviceNo' }
    ],
    show: false
  },
  // {
  //   propName: 'controlNo',
  //   label: '控制MAC',
  //   width: '160',
  //   show: false
  // },
  {
    propName: 'workStatusDesc',
    label: '工作状态',
    show: false
  },
  // {
  //   label: '工作状态',
  //   comOption: {
  //     name: 'workStatus',
  //     option: [
  //       { label: '已驻车', value: '0' },
  //       { label: '装料中', value: '1' },
  //       { label: '撒料中', value: '2' },
  //       { label: '充电中', value: '3' }
  //     ]
  //   },
  //   show: false
  // },
  {
    label: '车辆状态',
    width: '120',
    lineStatus: {
      name: 'deviceOnline',
      option: [
        { label: '离线', value: '1', mark: 'on' },
        { label: '在线', value: '0', mark: 'off' }
      ]
    },
    show: false
  },
  {
    label: '驾驶模式',
    comOption: {
      name: 'driverModel',
      option: [
        { label: '自动模式', value: '0' },
        { label: '手动模式', value: '1' }
      ]
    },
    width: '120',
    show: false
  },
  {
    propName: 'fullCapacity',
    label: '满载量(kg)',
    width: '120',
    show: false
  },
  {
    propName: 'alarmPhone',
    label: '告警联系电话',
    width: '160',
    show: false
  },
  {
    propName: 'speed',
    label: '车速(km/h)',
    width: '120',
    show: false
  },
  {
    propName: 'quantityOfElectricity',
    label: '电量(%)',
    width: '120',
    show: false
  },
  {
    propName: 'calculate',
    label: '余料(kg)',
    width: '120',
    show: false
  },
  {
    propName: 'createTime',
    label: '创建时间',
    show: false
  },
  {
    key: 'operation',
    label: '操作',
    fixed: 'right',
    align: 'center',
    width: '200',
    slot: {
      name: 'operation'
    },
    show: false
  }
];

export const feedingTaskSTitleData = {
  title: '饲喂任务',
  totalType: '',
  bntList: []
};
export const feedingTaskSTTableHeaderData = [
  {
    propName: 'timingName',
    label: '任务名称',
    show: false
  },
  {
    propName: 'openDate',
    label: '任务时间',
    width: '120'
  },
  {
    label: '计划饲喂棚',
    slot: {
      name: 'shed'
    },
    show: false
  },
  {
    label: '任务状态',
    slot: {
      name: 'timingType'
    },
    width: '100',
    show: false
  },
  {
    propName: 'fillFeedNo',
    label: '装料点',
    width: '100',
    show: false
  },
  {
    propName: 'aiSpeed',
    label: 'AI撒料速度',
    width: '100',
    show: false
  },
  {
    propName: 'setSpeed',
    label: '固定撒料速度',
    width: '120',
    show: false
  },
  {
    propName: 'feeLength',
    label: '撒料长度',
    width: '100',
    show: false
  },
  {
    label: '启停状态',
    slot: {
      name: 'openSign'
    },
    width: '100',
    show: false
  }
  // {
  //   propName: 'openSign',
  //   label: '启停状态',
  //   width: '150',
  //   show: false
  // }
];
export const feedingShedTitleData = {
  title: '计划饲喂棚',
  totalType: '',
  bntList: []
};
export const feedingShedTableHeaderData = [
  {
    propName: 'groupName',
    label: '区名称',
    show: false
  },
  {
    propName: 'shackName',
    label: '棚名称',
    show: false
  },
  {
    propName: 'deviceShackName',
    label: '棚内路名称',
    show: false
  },
  {
    propName: 'ofNumber',
    label: '次数',
    show: false
  },
  {
    label: '撒料方式',
    comOption: {
      name: 'type',
      option: [
        { label: 'AI饲喂', value: '1' },
        { label: '固定饲喂', value: '2' }
      ]
    },
    show: false
  }
  // {
  //   propName: 'type',
  //   label: '撒料方式',
  //   show: false
  // }
];

/* 饲喂记录 */
export const feedingRecordsNavData = [{ title: '饲喂管理', to: { path: '/homeZ/feedingVehicles' } }, { title: '饲喂记录' }];
export const feedingRecordsTitleData = {
  title: '饲喂记录',
  totalType: '',
  bntList: []
};
export const feedingRecordsSearchData = [
  {
    key: 'deviceType',
    types: 'select',
    value: '',
    valueName: 'deviceType',
    placeholder: '请选择设备类型',
    clearable: false,
    option: {
      data: [
        { label: '请选择设备类型', value: '' },
        { label: '撒料车', value: '3' },
        { label: '检测车', value: '6' },
        { label: '饲喂机器人', value: '7' }
      ],
      label: 'label',
      value: 'value'
    },
    appendToBody: true,
    style: {
      width: '150px'
    },
    show: false
  },
  {
    key: 'deviceName',
    types: 'input',
    value: '',
    valueName: 'deviceName',
    placeholder: '请输入设备名称搜索',
    clearable: true,
    style: {
      width: '180px'
    },
    show: false
  },
  {
    types: 'datePicker',
    value: [],
    valueType: 'Array',
    type: 'daterange',
    rangeSeparator: '至',
    startPlaceholder: '选择饲喂开始时间',
    endPlaceholder: '结束录入时间'
  }
];
export const feedingRecordsTableHeaderData = [
  {
    label: '设备类型',
    width: '120',
    comOption: {
      name: 'deviceType',
      option: [
        { label: '撒料车', value: '3' },
        { label: '检测车', value: '6' },
        { label: '饲喂机器人', value: '7' }
      ]
    },
    show: false
  },
  {
    label: '设备名称',
    width: '200',
    multipleLine: true,
    multipleData: [
      { color: 'blue', text: 'deviceName', tooltip: false },
      { color: 'color9', text: 'deviceNo' }
    ],
    show: false
  },
  {
    propName: 'beginTime',
    label: '饲喂时间',
    width: '240',
    show: false
  },
  {
    propName: 'rfidCount',
    label: 'RFID统计(只)',
    show: false
  },
  {
    propName: 'algorithmCount',
    label: 'AI算法数(只)',
    show: false
  },
  {
    propName: 'workTimeStr',
    label: '饲喂时长',
    show: false
  },
  {
    propName: 'totalOutWeight',
    label: '撒料量(kg)',
    show: false
  },
  {
    propName: 'avgEatWeight',
    label: '平均采食量(kg)',
    show: false
  },
  {
    key: 'operation',
    label: '操作',
    fixed: 'right',
    align: 'center',
    width: '200',
    slot: {
      name: 'operation'
    },
    show: false
  }
];
export const exportTableHeaderData = [
  // {
  //   propName: 'earNumber',
  //   label: '耳标号',
  //   show: false
  // }
  {
    label: '耳标号',
    multipleLine: true,
    multipleData: [{ color: 'bule', text: 'subEarNumber', tooltip: true, content: 'earNumber' }],
    show: false
  },
  {
    propName: 'sexDesc',
    label: '性别',
    width: '150',
    show: false
  },
  {
    propName: 'groupName',
    label: '所属区',
    width: '180',
    show: false
  },
  {
    propName: 'shackName',
    label: '所属棚',
    width: '180',
    show: false
  }
  // {
  //   propName: 'hurdleName',
  //   label: '所属栏',
  //   width: '140',
  //   show: false
  // },

  // {
  //   label: '性别',
  //   width: '100',
  //   slot: {
  //     name: 'sex'
  //   },
  //   show: false
  // }
];

/* TMR混料机 */
export const tmrNavData = [{ title: '饲喂管理', to: { path: '/homeZ/feedingVehicles' } }, { title: 'TMR中央厨房' }];
export const tmrTitleData = {
  title: '饲喂记录',
  totalType: '',
  bntList: []
};
export const tmrSearchData = [
  {
    key: 'deviceName',
    types: 'input',
    value: '',
    valueName: 'deviceName',
    placeholder: '请输入设备名称搜索',
    clearable: true,
    style: {
      width: '180px'
    },
    show: false
  },
  {
    key: 'workStatus',
    types: 'select',
    value: '',
    valueName: 'workStatus',
    placeholder: '请选择工作状态',
    clearable: false,
    option: {
      data: [
        { label: '请选择工作状态', value: '' },
        { label: '停止中', value: '4' },
        { label: '上料种', value: '1' },
        { label: '搅拌中', value: '2' },
        { label: '出料中', value: '3' }
      ],
      label: 'label',
      value: 'value'
    },
    appendToBody: true,
    style: {
      width: '150px'
    },
    show: false
  },
  {
    key: 'deviceOnline',
    types: 'select',
    value: '',
    valueName: 'deviceOnline',
    placeholder: '请选择在线状态',
    clearable: false,
    option: {
      data: [
        { label: '请选择在线状态', value: '' },
        { label: '在线', value: '0' },
        { label: '离线', value: '1' }
      ],
      label: 'label',
      value: 'value'
    },
    appendToBody: true,
    style: {
      width: '150px'
    },
    show: false
  }
];
export const tmrTableHeaderData = [
  {
    label: '设备名称',
    width: '250',
    multipleLine: true,
    multipleData: [
      { color: 'blue', text: 'deviceName', tooltip: false },
      { color: 'color9', text: 'deviceNo' }
    ],
    show: false
  },
  // {
  //   propName: 'controlNo',
  //   label: '控制MAC',
  //   show: false
  // },
  {
    label: '工作状态',
    comOption: {
      name: 'workStatus',
      option: [
        { label: '饲喂中', value: '1' },
        { label: '停止中', value: '2' },
        { label: '充电中', value: '3' },
        { label: '装料中', value: '4' }
      ]
    },
    show: false
  },
  {
    label: 'TMR设备状态',
    lineStatus: {
      name: 'onlineStatus',
      option: [
        { label: '离线', value: '1', mark: 'on' },
        { label: '在线', value: '0', mark: 'off' }
      ]
    },
    show: false
  },
  {
    propName: 'driverModel',
    label: '模式',
    width: '120',
    show: false
  },
  {
    propName: 'calculate',
    label: '余料(kg)',
    show: false
  },
  {
    propName: 'calculateRatio',
    label: '余料占比(%)',
    width: '120',
    show: false
  },
  {
    propName: 'goOnline',
    label: '重量上限(kg)',
    width: '150',
    show: false
  },
  {
    propName: 'offline',
    label: '重量下限(kg)',
    width: '150',
    show: false
  },
  {
    propName: 'name',
    label: '配方名称',
    show: false
  },
  {
    propName: 'createTime',
    label: '创建时间',
    width: '150',
    show: false
  },
  {
    key: 'operation',
    label: '操作',
    fixed: 'right',
    align: 'center',
    width: '160',
    slot: {
      name: 'operation'
    },
    show: false
  }
];

// 上料进度
export const siloSearchData = [
  {
    key: 'siloType',
    types: 'select',
    value: '',
    valueName: 'siloType',
    placeholder: '仓料类型',
    clearable: false,
    option: {
      data: [
        { label: '精料', value: '1' },
        { label: '粗料', value: '2' }
      ],
      label: 'label',
      value: 'value'
    },
    appendToBody: true,
    style: {
      width: '150px'
    },
    show: false
  }
];
export const siloTableTitleData = {
  title: '',
  totalType: '条数据',
  bntList: []
};
export const siloTableHeaderData = [
  {
    propName: 'siloName',
    label: '饲料名称',
    show: false
  },
  {
    propName: 'plannedQuantity',
    label: '计划量(kg)',
    width: '120',
    show: false
  },
  {
    propName: 'actualQuantity',
    label: '实际量(kg)',
    width: '120',
    show: false
  },
  {
    propName: 'errWeight',
    label: '误差重量(kg)',
    show: false
  },
  {
    propName: 'errProportion',
    label: '误差比例(%)',
    show: false
  },
  {
    propName: 'beginTime',
    label: '开始时间',
    show: false
  },
  {
    propName: 'endTime',
    label: '结束时间',
    show: false
  },
  {
    propName: 'duration',
    label: '过程时长',
    show: false
  }
];

// 混料计划
export const mixingTableTitleData = {
  title: '',
  totalType: '条数据',
  bntList: []
};

export const mixingTableHeaderData = [
  {
    propName: 'peiName',
    label: '配方名称',
    show: false
  },
  {
    propName: 'planTime',
    label: '计划时间',
    show: false
  },
  {
    propName: 'planKg',
    label: '计划量(kg)',
    show: false
  },
  {
    label: '任务状态',
    slot: {
      name: 'taskId'
    },
    show: false
  },
  {
    label: '启停状态',
    width: '120',
    comOption: {
      name: 'stopStatus',
      option: [
        { label: '开启', value: '1' },
        { label: '关闭', value: '2' }
      ]
    },
    show: false
  }
];

/* 混料/出料记录 */
export const mixtureNavData = [{ title: '饲喂管理', to: { path: '/homeZ/feedingVehicles' } }, { title: '混料/出料记录' }];
export const mixtureTabData = [
  { label: '混料记录', value: '0' },
  { label: '出料记录', value: '1' }
];
export const mixtrueSearchData = [
  {
    key: 'deviceName',
    types: 'input',
    value: '',
    valueName: 'deviceName',
    placeholder: '请输入设备名称',
    clearable: true,
    style: {
      width: '180px'
    },
    show: false
  },
  {
    key: 'formula',
    types: 'input',
    value: '',
    valueName: 'formula',
    placeholder: '请输入关联配方',
    clearable: true,
    style: {
      width: '180px'
    },
    show: false
  },
  {
    types: 'datePicker',
    value: [],
    valueType: 'Array',
    type: 'daterange',
    rangeSeparator: '至',
    startPlaceholder: '开始混料时间',
    endPlaceholder: '结束混料时间',
    style: {
      width: '350px'
    }
  }
];



// WEBPACK FOOTER //
// ./src/assets/data/smartAquacultureData.js